module.exports = __webpack_public_path__ + "static/media/avatar.763d8516.svg";